export const SET_STARTING_POINT = "SET_STARTING_POINT";
export const SET_DESTINATION = "SET_DESTINATION";

interface ActionTypes {
  SET_STARTING_POINT: any;
  SET_DESTINATION: any;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export function setStartingPoint(startingPoint: any): DirectionsActionsTypes {
  return {
    type: SET_STARTING_POINT,
    payload: startingPoint,
  };
}

export function setDestination(destination: any): DirectionsActionsTypes {
  return {
    type: SET_DESTINATION,
    payload: destination,
  };
}

export type DirectionsActionsTypes = MessageAction;
try {
    // @ts-ignore
    setStartingPoint.displayName = "setStartingPoint";
    // @ts-ignore
    setStartingPoint.__docgenInfo = { "description": "", "displayName": "setStartingPoint", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Directions/DirectionsActions.ts#setStartingPoint"] = { docgenInfo: setStartingPoint.__docgenInfo, name: "setStartingPoint", path: "src/shared/containers/Directions/DirectionsActions.ts#setStartingPoint" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setDestination.displayName = "setDestination";
    // @ts-ignore
    setDestination.__docgenInfo = { "description": "", "displayName": "setDestination", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Directions/DirectionsActions.ts#setDestination"] = { docgenInfo: setDestination.__docgenInfo, name: "setDestination", path: "src/shared/containers/Directions/DirectionsActions.ts#setDestination" };
}
catch (__react_docgen_typescript_loader_error) { }